
import { useState } from "react";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import { Utils } from "../../../../utils/Utils";
import Input from "../../../common/input/Input";
import Loading from "../../../common/loading/Loading";

export default function PriceSection({ workshop }) {
	const [isLoading, setIsLoading] = useState(false);
	const [message, setMessage] = useState("");
	const [errorMessage, setErrorMessage] = useState('');
	const [priceToman, setPriceToman] = useState(Utils.convertTomanComma(workshop.price));
	const [priceTomanWithDiscount, setPriceTomanWithDiscount] = useState('');
	const [discountCode, setDiscountCode] = useState('');

	const handlePurchase = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.workshopPreparePurchase({
			token: LoginHelper.getToken(),
			workshop_id: workshop.id,
			discount_code: discountCode,
		}).then((result) => {
			setIsLoading(false);
			setMessage('در حال انتقال به درگاه پرداخت...');
			window.location = result.gateway_url;
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	const handleCalculateDiscountCode = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.workshopCalculateDiscountCode({
			token: LoginHelper.getToken(),
			workshop_id: workshop.id,
			discount_code: discountCode,
		}).then((result) => {
			setIsLoading(false);
			setMessage(result.message);
			const discountAmount = result.discount_amount;
			setPriceTomanWithDiscount(Utils.convertTomanComma(workshop.price));
			setPriceToman(Utils.convertTomanComma(workshop.price - discountAmount));
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	return (
		<div className="bg-white rounded-[10px] p-[10px]">
			<div className="flex flex-row">
				<div className="font-Vazir-400 text-[14px] text-midGray">قیمت</div>
				<div className="spacer p-[5px]"></div>
				<div className="font-Vazir-400 text-[14px] text-midGray">{priceToman}</div>
				<div className="spacer p-[5px]"></div>
				<div className="font-Vazir-400 text-[14px] text-midGray">تومان</div>
				{priceTomanWithDiscount && (
					<>
						<div className="spacer p-[5px]"></div>
						<div className="font-Vazir-400 text-[14px] text-midGray line-through">{priceTomanWithDiscount}</div>
					</>
				)}
			</div>
			<div className="spacer p-[10px]"></div>
			<div>
				<div className="flex flex-row items-center">
					<Input
						value={discountCode}
						onChange={(e) => setDiscountCode(e.target.value)}
						label="کد تخفیف"
						placeholder="کد تخفیف"
					/>
					<div className="text-[#4B5155] font-Vazir-800 text-[14px] rounded-[10px] bg-[#F0F6FC] px-[10px] py-[5px] cursor-pointer mr-[10px]" onClick={handleCalculateDiscountCode}>محاسبه</div>
					{isLoading && (
						<>
							<div className="spacer p-[5px]"></div>
							<Loading color="#ff694b" width={16} />
						</>
					)}
					{message && (
						<>
							<div className="spacer p-[5px]"></div>
							<div className="font-Vazir-400 text-[14px] text-midGray">{message}</div>
						</>
					)}
				</div>
			</div>
			<div className="spacer p-[10px]"></div>
			<div>
				<div className="flex flex-row items-center">
					<div className="text-[#4B5155] font-Vazir-800 text-[14px] rounded-[10px] bg-[#F0F6FC] px-[10px] py-[5px] cursor-pointer" onClick={handlePurchase}>
						پرداخت
					</div>
					{isLoading && (
						<>
							<div className="spacer p-[5px]"></div>
							<Loading color="#ff694b" width={16} />
						</>
					)}
					{message && (
						<>
							<div className="spacer p-[5px]"></div>
							<div className="font-Vazir-400 text-[14px] text-midGray">{message}</div>
						</>
					)}
				</div>
			</div>
			{errorMessage && (
				<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
			)}
		</div>
	)
}
